export default "__VITE_ASSET__e09bfed5__"